export default function videoSeries() {
  return {
    _id: false,
    type: 'droplet.videoSeries',
    episodes: [],
    episodesJSON: '{ "list": [] }',
    mediaQueries: [
      {
        selector: '.drzVideo-progress',
        properties: [
          {
            defaultColor: true,
            property: 'background-color',
            desktop: 'default',
            tablet: 'default',
            mobile: 'default',
          },
        ],
      },
    ],
    pageCSS: '',
    bounceDroplet: false,
    isShared: false,
    templateRegion: false,
  };
}



// WEBPACK FOOTER //
// ./src/global-view/editor/droplets/video-series/droplet.schema.js